import './dataRibbon.css';

export const DataRibbon = () => {
    return (
        <section className="content">
            <div className="wrapper">
                <div className="data_item">
                    <div className="data_num">50</div>
                    <div className="data_label">Students Class 10th</div>
                </div>
                <div className="data_item">
                    <div className="data_num">33</div>
                    <div className="data_label">Students Class 9th</div>
                </div>
                <div className="data_item">
                    <div className="data_num">1</div>
                    <div className="data_label">Principal</div>
                </div>
                <div className="data_item">
                    <div className="data_num">4</div>
                    <div className="data_label">Teachers</div>
                </div>
            </div>
        </section>
    )
}
